import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  inject,
  signal,
} from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MegaMenu } from 'primeng/megamenu';
import { TabsModule } from 'primeng/tabs';
import { SecurityService } from '../../../core/services/security.service';
import { GraphService } from '../../../core/services/graph.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { MegaMenuItem } from 'primeng/api';
import { AccountInfo } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { Dialog } from 'primeng/dialog';
@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    TabsModule,
    RouterModule,
    MegaMenu,
    ButtonModule,
    CommonModule,
    AvatarModule,
    Dialog,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  private _securityService = inject(SecurityService);
  private _graphService = inject(GraphService);
  private _msalService = inject(MsalService);

  visible = false;

  items = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {},
    },
  ];

  protected _profilePictureUrl$ = this._securityService.hasActiveAccount$.pipe(
    switchMap((hasAccount: boolean) => {
      if (!hasAccount) {
        return of(null);
      }

      return this._graphService.getProfilePicture().pipe(
        map((blob) => URL.createObjectURL(blob)),
        catchError((error) => {
          console.error('Error loading profile picture', error);
          return of(null);
        })
      );
    })
  );

  protected _accountInitials$ = this._securityService.activeAccount$.pipe(
    map((account: AccountInfo | undefined) => {
      if (!account || !account.name) return;

      let nameParts = account?.name.split(' ');
      return [nameParts[0], nameParts[nameParts.length - 1]]
        .map((namePart) => namePart[0])
        .join('')
        .toUpperCase();
    })
  );

  showDialog() {
    console.log('clicked')
    this.visible = true;
    console.log(this.visible)
  }

  public async logout() {
    try {
      await this._msalService.logoutRedirect();
      console.log('logout completed');
    } catch (error) {
      if (error instanceof Error) {
        console.error('logout failed', error);
      }
    }
  }

  tabs = signal<MegaMenuItem[]>([
    {
      label: 'Home',
      subtext: 'test',
      url: '/',
      root: true,
      routerLink: '/',
    },
    {
      label: 'Keyphrase Extraction',
      url: '/keyphrase-extraction',
      // icon: 'pi pi-fw pi-file-o',
      routerLink: 'keyphrase-extraction',
      root: true,
    },
    {
      label: 'Topic Classification',
      url: '/topic-classification',
      // icon: 'pi pi-fw pi-file',
      routerLink: 'topic-classification',
      root: true,
    },
  ]);
}
